import Navbar from '../components/Navbar';

const HomePage = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default HomePage;
